import React from "react";

import "./menu_Default.css";

const Menu_Icon = () => (
  <svg id="Menu" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <path
      id="Rectangle_675"
      data-name="Rectangle 675"
      className="horizontalMenu-1"
      d="M2,0H30a2,2,0,0,1,2,2V32a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z"
    />
    <g id="Menu_Icon" className="horizontalMenu" data-name="Menu Icon" transform="translate(8.5 14.5)">
      <circle id="Ellipse_49" data-name="Ellipse 49" className="horizontalMenu-2" cx="1.5" cy="1.5" r="1.5" />
      <circle id="Ellipse_50" data-name="Ellipse 50" className="horizontalMenu-2" cx="1.5" cy="1.5" r="1.5" transform="translate(6)" />
      <circle id="Ellipse_51" data-name="Ellipse 51" className="horizontalMenu-2" cx="1.5" cy="1.5" r="1.5" transform="translate(12)" />
    </g>
  </svg>
);

export default Menu_Icon;
